import AnimatedBanner from "@src/components/libraryItemDetailPages/course/AnimatedBanner";
import useVersionQueryParams from "@src/components/libraryItemDetailPages/hooks/useVersionQueryParams";
import { cn } from "@src/ui/lib/utils";

const LockedTrainingResourceVersionBanner: React.FC = () => {
  const { version } = useVersionQueryParams();

  return (
    <div
      className={cn(
        "flex flex-col self-stretch px-3",
        version === "published" && "mb-3",
      )}
    >
      <AnimatedBanner
        showBanner={version === "published"}
        text="You're viewing the Published version. Select the Draft version to make changes."
      />
    </div>
  );
};

export default LockedTrainingResourceVersionBanner;
